module.exports = __webpack_public_path__ + "static/img/btn.2cdba335.png";